var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M0 16.67h100v11.11H0V16.67zm0 27.77h72.23v11.12H0V44.44zm83.2 16.52l16.62-10.9-16.63-10.9v21.8zM0 72.22h100v11.11H0V72.22z", "fill-rule": "nonzero" } }] }, name: "open", theme: "filled" };
export {
  e as default
};
